import React, { useState, KeyboardEvent } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { InputContainer, Input, SendButton } from './styles';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled: boolean;
  isDarkMode: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled, isDarkMode }) => {
  const { t } = useLanguage();
  const [value, setValue] = useState('');

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend(value);
      setValue('');
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <InputContainer isDarkMode={isDarkMode}>
      <Input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={t('widget.placeholder')}
        disabled={disabled}
        isDarkMode={isDarkMode}
        aria-label={t('widget.placeholder')}
      />
      <SendButton
        onClick={handleSend}
        disabled={disabled || !value.trim()}
        isDarkMode={isDarkMode}
        aria-label={t('widget.send')}
        title={t('widget.send')}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </SendButton>
    </InputContainer>
  );
};

export default ChatInput;
